(function($) {
    var mobileWidth = 767;
    var isMobile = window.innerWidth < mobileWidth;

    window.onresize = function (e) {
        isMobile = window.innerWidth < mobileWidth;
        // console.log(isMobile);
    }

    var $tabsControls = $(".js-products-tabs");
    var $tabsSlides = $(".js-tabs__slide");
    var activeClass = "is-active";

    if (!$tabsControls.length || !$tabsSlides.length) return;
    
    var $buttons = $(".js-products-tabs__item", $tabsControls);

    $buttons.click(buttonHahdle);

    function buttonHahdle(e) {
        if (isMobile) return;
        
        e.preventDefault();
        
        var $target = $(e.currentTarget);
        var $nextTab = $("." + $target.data("tab"));

        // console.log($target.data("tab"));
        $buttons.removeClass(activeClass);
        $target.addClass(activeClass);
        $tabsSlides.removeClass(activeClass);
        $nextTab.addClass(activeClass);
    }
})(jQuery);



// WEBPACK FOOTER //
// ./common.blocks/tabs/tabs.js